import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const GET_BUNDLE = apiPromiseTypes('products-bundle', 'get');
export const BUNDLE_NOT_FOUND = `waitrose/api/products-bundle/get/not-found`;
